import {initElements} from "../define/shared"

export default function initHeader() {
    initElements(".siteHeader", header => {
        const humb = header.querySelector('.siteHeader-humb'),
            navMob = header.querySelector('.siteHeader-mobNav'),
            childMenu = navMob.querySelectorAll('.menu-item-has-children'),
            closeBtn = navMob.querySelector('.btn-close')

        window.addEventListener('scroll', () => {
            window.pageYOffset > 0 ? header.classList.add('onscroll') : header.classList.remove('onscroll')
        })

        humb.addEventListener('click', () => {
            navMob.classList.add('--open')
        })

        closeBtn.addEventListener('click', () => {
            navMob.classList.remove('--open')
        })

        childMenu.forEach(li => {
            let wrapper = document.createElement('div'),
                arrow = document.createElement('span')

            arrow.classList.add('icon', 'icon-arrow-down')
            wrapper.classList.add('wrapper')

            wrapper.append(li.querySelector('a'))
            wrapper.append(arrow)

            li.prepend(wrapper)

            arrow.addEventListener('click', () => {
                li.classList.toggle('--open')
            })

        })

    })
}
